import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_PBISMaintenance } from "../shared/data.service";
import { PBISPointItemAddRequest } from "../shared/PBISPointItemAddRequest";

@Component({
	selector: "app-point-maint-add",
	templateUrl: "./point-maint-add.component.html",
	styleUrls: ["./point-maint-add.component.css"],
})
export class PointMaintAddComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private PBISService: DataService_PBISMaintenance,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.SchoolID = this.dialogConfig.data.SchoolID;

		this.loadPointsCategoryType();
	}

	///////////////////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////////////////
	SchoolID: any;

	PointsItemDesc: any = "";

	PointsCategoryType: any;
	lstPointsCategoryType: any = [];

	PointsCategory: any;
	lstPointsCategory: any = [];

	PointsItemValue: any = 0;

	UseInClassroom: boolean = false;

	LoadingType: any = true;
	LoadingCategory: any = true;
	Processing: any = false;

	DisableClass: any = false;

	///////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////////////////////
	loadPointsCategoryType() {
		this.LoadingType = true;

		var result = this.PBISService.PBISPointsCategoryTypeGetList();
		result.subscribe(
			(response) => {
				this.lstPointsCategoryType = response;

				this.PointsCategoryType = this.lstPointsCategoryType[0];

				this.LoadingType = false;

				this.loadPointsCategory();
			},
			(error) => {
				this.LoadingType = false;
			}
		);
	}

	loadPointsCategory() {
		this.LoadingCategory = true;

		var result = this.PBISService.PBISPointsCategoryGetList(this.PointsCategoryType.PointsCategoryTypeID);
		result.subscribe(
			(response) => {
				this.lstPointsCategory = response;

				this.PointsCategory = this.lstPointsCategory[0];
				if (this.PointsCategory.UseInClassRoom == 0) {
					this.UseInClassroom = false;
					this.DisableClass = true;
				}

				this.LoadingCategory = false;
			},
			(error) => {
				this.LoadingCategory = false;
			}
		);
	}

	///////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////////////////////
	onAdd() {
		let parms: PBISPointItemAddRequest = {
			PointsItemDesc: this.PointsItemDesc,
			PointsItemValue: this.PointsItemValue,
			PointsCategoryID: this.PointsCategory.PointsCategoryID,
			UseInClassRoom: this.UseInClassroom == true ? 1 : 0,
			SchoolID: this.SchoolID,
		};

		var result = this.PBISService.PBISPointItemAdd(parms);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Point was added successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add the point",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////////////////////
	onTypeChange(val) {
		this.PointsCategoryType = val;

		this.loadPointsCategory();
	}

	onCategoryChange(val) {
		this.PointsCategory = val;

		this.DisableClass = false;

		if (this.PointsCategory.UseInClassRoom == 0) {
			this.UseInClassroom = false;
			this.DisableClass = true;
		}
	}

	///////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////////////////////
	IsLoading() {
		return this.LoadingType == true || this.LoadingCategory == true || this.Processing == true;
	}
	///////////////////////////////////////////////////////////////////////
}
